import React, { useState, useEffect } from 'react';
import { getSettings } from '../../util/getSettings';
import Checkbox from '../shared/checkbox';

const HomeTypes = ({ selectedHomeTypes, onChange }) => {
  const [homeTypes, setHomeTypes] = useState([]);
  const labels = getSettings(['century', 'labels'], true);
  const settings = getSettings(['century', 'settings']);

  useEffect(() => {
    setHomeTypes(homeTypesValues);
    if (selectedHomeTypes) {
      setSelectedHomeTypes(selectedHomeTypes);
    }
  }, [homeTypesValues]);

  const homeTypesValues = settings.homeTypes
    .split(',')
    .map((homeType) => ({ homeType, label: homeType, checked: false }));

  const setSelectedHomeTypes = (selectedHomeTypes) => {
    if (selectedHomeTypes && selectedHomeTypes.length > 0) {
      selectedHomeTypes.split(',').map((type) => {
        const selectedHomeIndex = homeTypesValues.findIndex((home) => home.label === type);
        homeTypesValues[selectedHomeIndex].checked = true;
        setHomeTypes(homeTypesValues);
      });
    }
  };

  const onSelect = (value) => {
    const homeTypesCopy = homeTypes;
    const updatedHomeIndex = homeTypesCopy.findIndex((home) => home.homeType === Object.keys(value)[0]);
    homeTypesCopy[updatedHomeIndex].checked = Object.values(value)[0];
    setHomeTypes(homeTypesCopy);
    onChange(
      homeTypesCopy
        .filter((type) => {
          return type.checked === true;
        })
        .map((selected) => selected.label)
        .join(',')
    );
  };

  return (
    <fieldset>
      <legend className="filter-title">{labels.homeTypeFilterLabel}</legend>
      {homeTypes.map((type, index) => (
        <Checkbox
          key={index}
          value={type.homeType}
          id={type.homeType}
          label={type.label}
          onChange={onSelect}
          checked={type.checked}
        />
      ))}
    </fieldset>
  );
};

export default HomeTypes;
